// extracted by mini-css-extract-plugin
export default {"footerAlign":"WhiteLabeling_footerAlign__rgEzF"};